/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getGpcComps as getGpcCompsService } from 'dashboard409a/services/dashboard';
import { CompsDataType, IGetGpcCompsResponse } from 'dashboard409a/services/types';
import { IGpcCompsState } from './types';

const initialState: IGpcCompsState = {
  loading: false,
  valueOverTime: null,
  rateOfChange: null,
  currentValue: null,
  medians: null,
  error: null,
};

export const getGpcComps = createAsyncThunk<
  { response: IGetGpcCompsResponse; dataType: CompsDataType },
  { dateId: number; dataType: CompsDataType }
>(
  'gpcComps/getGpcComps',
  async ({ dateId, dataType }, thunkAPI) => {
    try {
      const response = await getGpcCompsService(dateId, dataType);
      return { response, dataType };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const gpcCompsSlice = createSlice({
  name: 'gpcComps',
  initialState,
  reducers: {
    clearGpcCompsData: state => {
      state.valueOverTime = null;
      state.rateOfChange = null;
      state.currentValue = null;
      state.medians = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getGpcComps.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGpcComps.fulfilled, (state, { payload }) => {
        state.loading = false;
        // Store in the specific data stores based on data type
        if (payload.dataType === CompsDataType.VALUE_OVER_TIME) {
          state.valueOverTime = payload.response.value_over_time;
        } else if (payload.dataType === CompsDataType.RATE_OF_CHANGE) {
          state.rateOfChange = payload.response.rate_of_change;
        } else if (payload.dataType === CompsDataType.CURRENT_AND_MEDIANS) {
          state.currentValue = payload.response.current_value;
          state.medians = payload.response.medians;
        }
      })
      .addCase(getGpcComps.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as Error | string) || 'Failed to fetch GPC data';
      });
  },
});

export const { clearGpcCompsData } = gpcCompsSlice.actions;
export default gpcCompsSlice.reducer;
